import { render } from "./UserUpcomingLabs.vue?vue&type=template&id=29d423fe"
import script from "./UserUpcomingLabs.vue?vue&type=script&lang=js"
export * from "./UserUpcomingLabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__